/**
 * The standing explanation of when money actually moves.
 *
 * Quiet by design: it is not a warning and not an error. It sits under the
 * thing it explains in the same shape every time, so a client who has read it
 * once recognises it and skips it, and one who has not can find the whole
 * answer without asking anybody.
 */
import { settlementLegend, type LegendTone, type SettlementLegend } from '../../lib/settlementTiming';
import { colors } from '../../styles/theme';

export default function BusinessDayLegend({ tone, legend }: Readonly<{
  /** Which of the three situations the client is in. Ignored when `legend` is given. */
  tone?: LegendTone;
  /** A legend already chosen by the caller — e.g. the one a refusal carries. */
  legend?: SettlementLegend | null;
}>): JSX.Element | null {
  const chosen = legend ?? (tone ? settlementLegend(tone) : null);
  if (!chosen) return null;
  return (
    <section
      className="rounded-lg px-3 py-2 text-xs"
      style={{ background: colors.surfaceMuted ?? colors.surface, border: `1px solid ${colors.border}` }}
    >
      <p className="font-semibold mb-0.5" style={{ color: colors.ink }}>{chosen.title}</p>
      <p style={{ color: colors.inkSoft }}>{chosen.body}</p>
    </section>
  );
}
